import { StandardEvents } from '@shopify/events';

/**
 * Digital patterns are always quantity 1. If a shopper clicks "Add to cart"
 * for a pattern already in their cart, block the real add (which would
 * otherwise bump the line to quantity 2) and show a gentle "Already in your
 * cart" state on the button instead of a confusing second line or a silent
 * no-op.
 */

/** @type {Set<string>} Variant IDs (as strings) currently in the cart. */
let cartVariantIds = new Set();

async function refreshCartVariantIds() {
  try {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    cartVariantIds = new Set((cart.items ?? []).map((item) => String(item.variant_id)));
  } catch (_error) {
    // Network hiccup: fail open (treat cart as unknown, let the real add proceed).
  }
}

refreshCartVariantIds();
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  // The event fires when the add STARTS, not when it finishes — its own
  // `promise` resolves once the server confirms the change, so wait for
  // that before re-reading /cart.js (otherwise we'd race the request).
  event.promise?.then(() => refreshCartVariantIds()).catch(() => {});
});

/**
 * @param {HTMLButtonElement} button
 */
function showAlreadyInCart(button) {
  button.setAttribute('data-already-in-cart', 'true');
  window.setTimeout(() => {
    button.removeAttribute('data-already-in-cart');
  }, 1800);
}

document.addEventListener(
  'click',
  (event) => {
    const target = /** @type {HTMLElement} */ (event.target);
    const button = target?.closest?.('button[type="submit"][name="add"]');
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    const form = button.closest('form');
    const variantInput = form?.querySelector('input[name="id"]');
    const variantId = variantInput instanceof HTMLInputElement ? variantInput.value : null;
    if (!variantId || !cartVariantIds.has(variantId)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    showAlreadyInCart(button);
  },
  true
);
